import cx from 'classnames';
import { useEffect, useState } from 'react';
import "./LimitUsageBar.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LimitUsageBar = _ref => {
  let {
    availableDesc,
    progress,
    usedDesc
  } = _ref;
  if (progress < 0 || progress > 1) throw new Error('"progress" property must be in 0..1 range');
  const [didMount, setDidMount] = useState(false);
  useEffect(() => setDidMount(true), []);
  return /*#__PURE__*/_jsxs("div", {
    className: "LimitUsageBar",
    "data-sentry-component": "LimitUsageBar",
    "data-sentry-source-file": "LimitUsageBar.tsx",
    children: [(availableDesc || usedDesc) && /*#__PURE__*/_jsxs("div", {
      className: "LimitUsageBar__description",
      children: [/*#__PURE__*/_jsx("div", {
        className: "LimitUsageBar__used",
        children: usedDesc
      }), /*#__PURE__*/_jsx("div", {
        className: "LimitUsageBar__available",
        children: availableDesc
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "LimitUsageBar__bar",
      children: /*#__PURE__*/_jsx("div", {
        className: cx('LimitUsageBar__progress', progress > 0.8 && 'LimitUsageBar__progress--danger'),
        style: {
          width: `${didMount ? progress * 100 : 0}%`
        }
      })
    })]
  });
};
export default LimitUsageBar;